import React from 'react';
import ViewCustomer from '../../components/customer_comp/ViewCustomer';

/**
 * ViewCustomerPage — Page wrapper for View Customer list module
 * Bootstrap 5 layout. GTSS colors via gtss- utility classes.
 */
const ViewCustomerPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <ViewCustomer />
        </div>
    );
};

export default ViewCustomerPage;